import React, { useEffect } from 'react';

interface Props {
  title: string;
}

const Title: React.FunctionComponent<Props> = (props) => {
  useEffect(() => {
    document.title = props.title;
  }, [props.title]);
  return <div />;
};

export default Title;
